module.exports = {
	"id": "NZ",
	"name": "New Zealand",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.012512,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.006256,
			"22": 0.018768,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.018768,
			"27": 0.006256,
			"28": null,
			"29": null,
			"30": 0.006256,
			"31": 0.043792,
			"32": 0.006256,
			"33": 0.018768,
			"34": 0.037536,
			"35": 0.018768,
			"36": 0.018768,
			"37": 0.025024,
			"38": 0.050048,
			"39": 0.081328,
			"40": 0.025024,
			"41": 0.03128,
			"42": 0.068816,
			"43": 0.081328,
			"44": 0.100096,
			"45": 0.394128,
			"46": 0.06256,
			"47": 0.181424,
			"48": 0.09384,
			"49": 1.582768,
			"50": 0.21896,
			"51": 0.613088,
			"52": 0.919632,
			"53": 26.406576,
			"54": 5.986992,
			"55": 0.075072,
			"56": 0.03128,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.006256,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.006256,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.006256,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.006256,
			"29": 0.012512,
			"30": null,
			"31": 0.018768,
			"32": null,
			"33": 0.006256,
			"34": 0.012512,
			"35": null,
			"36": 0.006256,
			"37": 0.025024,
			"38": 0.068816,
			"39": 0.037536,
			"40": 0.018768,
			"41": 0.037536,
			"42": 0.03128,
			"43": 0.068816,
			"44": 0.037536,
			"45": 0.1564,
			"46": 0.043792,
			"47": 0.37536,
			"48": 0.481712,
			"49": 5.59912,
			"50": 0.056304,
			"51": 0.006256,
			"52": null,
			"3.5": null,
			"3.6": 0.006256
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.012512,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.018768,
			"37": 0.025024,
			"38": 0.018768,
			"39": 0.012512,
			"40": 0.175168,
			"41": 0.03128,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.025024
		},
		"safari": {
			"0": null,
			"4": 0.012512,
			"5": 0.09384,
			"6": 0.012512,
			"7": 0.043792,
			"8": 0.331568,
			"9": 0.387872,
			"10": 2.15832,
			"3.1": null,
			"3.2": null,
			"5.1": 0.137632,
			"6.1": 0.100096,
			"7.1": 0.012512,
			"9.1": 1.62656
		},
		"ios_saf": {
			"8": 0,
			"10": 11.5971206078,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.312528981057,
			"8.1-8.4": 0.57738404975,
			"9.0-9.2": 0.27544927144,
			"9.3": 4.20236708993
		},
		"android": {
			"3": 0,
			"4": 0.0272310852713,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00340388565891,
			"4.1": 0.0982264147287,
			"4.2-4.3": 0.245566036822,
			"4.4": 0.56309994186,
			"4.4.3-4.4.4": 0.567962635659
		},
		"ie": {
			"6": null,
			"7": 0.00631264386318,
			"8": 0.189379315895,
			"9": 0.227255179074,
			"10": 0.208317247485,
			"11": 5.63719096982,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0188533527673,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000523704243535
		},
		"edge": {
			"12": 0.081328,
			"13": 0.644368,
			"14": 2.458608
		},
		"ie_mob": {
			"10": 0.0701528169014,
			"11": 0.285622183099
		},
		"bb": {
			"7": 0.00842625,
			"10": null
		},
		"samsung": {
			"0": 3.426675
		},
		"and_uc": {
			"0": 0.68159
		},
		"op_mini": {
			"0": 0.254007942989
		},
		"and_chr": {
			"0": 16.474019
		},
		"and_ff": {
			"0": 0.02996
		}
	},
	"total": 98.7830096061
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/NZ.json
 ** module id = 615
 ** module chunks = 0
 **/